import type { MutableRefObject } from "react";

import type { PendingSupervise, SuperviseMode } from "~/services/calling/types";

/** Window when the operator initiated supervise (Listen/Barge button). */
export const SUPERVISE_AUTO_ACCEPT_WINDOW_MS = 5_000;

/** Window when another operator invited this user via warm handoff. */
export const INVITED_SUPERVISE_AUTO_ACCEPT_WINDOW_MS = 15_000;

export function preparePendingSupervise(
  pendingSuperviseRef: MutableRefObject<PendingSupervise | null>,
  pendingSuperviseTimeoutRef: MutableRefObject<number | null>,
  mode: SuperviseMode,
  windowMs = SUPERVISE_AUTO_ACCEPT_WINDOW_MS
) {
  if (pendingSuperviseTimeoutRef.current != null) {
    window.clearTimeout(pendingSuperviseTimeoutRef.current);
  }

  pendingSuperviseRef.current = { mode, atMs: Date.now() };
  pendingSuperviseTimeoutRef.current = window.setTimeout(() => {
    pendingSuperviseRef.current = null;
    pendingSuperviseTimeoutRef.current = null;
  }, windowMs);
}
